var React = require('react');

function DownloadInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M9.93028 14.1765V2.57605H11.601V14.1765L16.8577 9.4927L18.0391 10.5453L10.7656 17.026L3.49219 10.5453L4.67354 9.4927L9.93028 14.1765Z","fill":"#009696","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M20.7897 21.9277H0.741455V20.4391H20.7897V21.9277Z","fill":"#009696","key":1})]);
}

DownloadInline.defaultProps = {"width":"21","height":"22","viewBox":"0 0 21 22","fill":"none"};

module.exports = DownloadInline;

DownloadInline.default = DownloadInline;
